const signup = {
  setScreenName: ({ state }, payload) => {
    state.signup.screenName = payload
  },
  setDocument: ({ state }, payload) => {
    state.signup.document = payload
  },
  setEmail: ({ state }, payload) => {
    state.signup.email = payload
  },
  setVerificationTicket: ({ state }, payload) => {
    state.signup.verificationTicket = payload
  },
}

export { signup }
